import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APP_CONSTANTS } from '@shared/core';
import { DefaultMenuComponent } from '../default-menu/default-menu.component';
import { DefaultNavigationComponent } from '../default-navigation/default-navigation.component';

@Component({
    selector: 'shared-default-layout',
    imports: [RouterModule, DefaultMenuComponent, DefaultNavigationComponent],
    templateUrl: './default-layout.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultLayoutComponent {
    private readonly appConstants = inject(APP_CONSTANTS);
    public version = this.appConstants.environment.VERSION;
}
